import "./App.css";
import Routes from "./Routes/routes";
import RegisterPage from "./Components/RegisterPage";

function App() {
  return (
    <div className="App">
      <Routes />
    </div>
  );
}

export default App;
